import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import 'react-select/dist/react-select.css';

import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            tipo: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id,
            tipo: data.tipo_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.responsables.edit}
                postUrl={api.clientes.responsables.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Contacto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Contacto"}
                buttonTitle={"Editar Contacto"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <div className="ui-section-grid ">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Nombre</Label>
                                    <Input type="text" name="nombre"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Apellido</Label>
                                    <Input type="text" name="apellido"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa</Label>
                                    <ParadigmaAsyncSeeker fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos de contacto</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Tipo</Label>
                                    <ParadigmaAsyncSeeker value={this.state.tipo} fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Teléfono</Label>
                                    <Input type="text" name="telefono" ></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input type="text" name="email"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" rows="5"/>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Edit.js